module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/6205cc32b06d4bc26215ac579af29164.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/images/img_question_marks_left.svg
// module id = hjwG
// module chunks = 0